import React from 'react';
import { bonuses } from '../../data/content';
import { CtaButton } from './CtaButton';
export function Bonuses() {
  return <section id="bonuses" className="bg-ink py-16 text-cream sm:py-20" data-id="element-30" data-mp="8um8iq9xzqbv">
      <div className="mx-auto max-w-7xl px-6 lg:px-10" data-id="element-31" data-mp="3r8daxlynumid">
        <div className="mx-auto max-w-3xl text-center" data-id="element-32" data-mp="3r5qx54l6farp">
          <p className="text-xs font-bold uppercase tracking-[0.22em] text-gold" data-id="element-33" data-mp="3vagp4icps57c">And because we want this to actually help you…</p>
          <h2 className="mt-4 font-serif text-3xl font-bold leading-tight sm:text-4xl" data-id="element-34" data-mp="muets62p9ecg">
            You'll also get these 8 bonuses <em className="text-gold" data-id="element-35" data-mp="rqcaidhvkmpr">completely free</em>
          </h2>
        </div>

        <ol className="mt-10 grid grid-cols-2 gap-x-4 gap-y-8 lg:grid-cols-4 lg:gap-x-6" data-id="element-36" data-mp="dv1kbdeksprq">
          {bonuses.map((b, i) => <li key={b.title} className="flex flex-col" data-id="element-37" data-mp="2yjftfl29wtqo" data-mpi={i}>
              <img src={b.image} alt={`Bonus ${i + 1}: ${b.title} guide preview`} loading="lazy" className="aspect-square w-full rounded-[4px] object-cover" data-id="element-38" data-mp="2yhv204b99qx1" />
              <h3 className="mt-3 font-serif text-base font-bold leading-snug sm:text-lg" data-id="element-39" data-mp="sykr081v4ptf">{b.title}</h3>
              <p className="mt-1 line-clamp-2 text-[13px] leading-relaxed text-cream/70" data-id="element-40" data-mp="17vbwmz24qxrh">{b.subtitle}</p>
              <div className="mt-auto flex items-center gap-2 pt-3" data-id="element-41" data-mp="12vz9ed7cjood">
                <span className="text-xs text-cream/50 line-through" data-id="element-42" data-mp="12yv4zuvq219n">{b.price}</span>
                <span className="text-xs font-bold uppercase tracking-wider text-gold-soft" data-id="element-43" data-mp="1gu7043dshtr3">Today: Free</span>
              </div>
            </li>)}
        </ol>

        <div className="mt-10 flex justify-center" data-id="element-44" data-mp="1qkrvzj22wk6b">
          <CtaButton variant="gold" className="w-full sm:w-auto" data-id="element-45" data-mp="1ln03onxiuw1l">I want all 8 free bonuses</CtaButton>
        </div>
      </div>
    </section>;
}